<template>
  <div class="nuance-badges" v-if="nuances && nuances.length">
    <span
      v-for="n in nuances"
      :key="n.code"
      class="badge-item"
      :style="{ backgroundColor: n.color }"
      :title="n.detail"
    >
      {{ n.label }}
    </span>
  </div>
</template>

<script>
import { GET_COMPANY_NUANCES } from "../../../../urlConfig";
import { REQUEST_SERVICE } from "../../../../requestConfig";

export default {
  name: "companyNuanceBadges",
  props: {
    companyId: { type: String, required: true },
    // contentSetting da empresa (vem da rota) — necessário pro backend
    // rotear ao shard correto. Se não passar, cai no contexto do master.
    context: { type: String, default: "" }
  },
  data() {
    return {
      nuances: []
    };
  },
  watch: {
    companyId: {
      immediate: true,
      handler(val) {
        if (val) this.load();
      }
    }
  },
  methods: {
    load() {
      REQUEST_SERVICE.requestContext(
        "GET",
        `${GET_COMPANY_NUANCES}?companyId=${this.companyId}`,
        this.context || (this.$route && this.$route.params.context)
      ).then((response) => {
          const data = response.data || {};
          this.nuances = Array.isArray(data.nuances) ? data.nuances : [];
        })
        .catch(() => { this.nuances = []; });
    }
  }
};
</script>

<style lang="scss" scoped>
.nuance-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 8px 0;

  .badge-item {
    color: #fff;
    font-size: 11px;
    padding: 3px 10px;
    border-radius: 12px;
    font-weight: 600;
    letter-spacing: 0.3px;
    cursor: help;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/layouts/companyNuanceBadges.vue